var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"title":"Add","icon":"mdi-plus"},on:{"click":_vm.add}})
}
var staticRenderFns = []

export { render, staticRenderFns }